import axios from 'axios';

/**
 * Generic Lambda function caller
 * Works with any Lambda endpoint and payload
 * 
 * @param {string} endpoint - Lambda endpoint URL
 * @param {object} payload - Request payload
 * @returns {Promise} Response from Lambda
 */
export async function callLambdaFunction(endpoint, payload) {
  try {
    const response = await axios?.post(endpoint, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response?.data;
  } catch (error) {
    // Log for monitoring
    if (error?.response?.data?.error) {
      console.error('Lambda Function Error:', {
        error: error?.response?.data?.error,
        details: error?.response?.data?.details,
        status: error?.response?.status,
      });
      
      // Inclure le code de statut HTTP dans le message d'erreur
      const statusCode = error?.response?.status;
      const errorMessage = error?.response?.data?.error;
      const errorDetails = error?.response?.data?.details;
      
      throw new Error(
        statusCode 
          ? `[${statusCode}] ${errorMessage}${errorDetails ? ': ' + errorDetails : ''}`
          : errorMessage
      );
    }
    
    // Gestion des erreurs réseau ou autres
    if (error?.response?.status) {
      console.error('HTTP Error:', {
        status: error?.response?.status,
        statusText: error?.response?.statusText,
      });
      throw new Error(`Erreur HTTP ${error.response.status}: ${error.response.statusText}`);
    }
    
    console.error('Lambda function error:', error);
    throw new Error(error?.message || 'Erreur de connexion au service IA');
  }
}